<!--<div>
  <div style="display: block">
   <canvas #chart baseChart
            [datasets]="data"
            [labels]="ChartLabels"
            [options]="ChartOptions"
            [legend]="ChartLegend"
            [chartType]="Type"
            [colors]="myColors"
          ></canvas>
  </div>

</div>-->




<div *ngIf="ChartData?.data?.length > 0" class="w-100 graph" #graph></div>
<h1 *ngIf="ChartData?.data?.length == 0" class="text-center q-c-light-main q-font"><i class="fas fa-chart-bar"></i> Pas de données à afficher</h1>
